import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Container } from "../layout/Container";
import SectionHeaderRow from "../shared/SectionHeaderRow";
import CouponCard from "../cards/CouponCard";
import { cPath } from "../../constants";

const Section = styled.section`
  padding: 2rem 0;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Empty = styled.p`
  margin: 0;
  text-align: center;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  font-size: 0.9375rem;
`;

export default function HomeLatestCoupons({ coupons = [] }) {
  const { t } = useTranslation();
  const recentCoupons = (coupons || []).slice(0, 6);

  return (
    <Section>
      <Container>
        <SectionHeaderRow
          title={t("home.latestCoupons.title")}
          to={cPath("submit-deal")}
          linkLabel={t("home.latestCoupons.submitDeal")}
          marginBottom="1.5rem"
        />
        {recentCoupons.length === 0 ? (
          <Empty>{t("home.latestCoupons.noCoupons")}</Empty>
        ) : (
          <List>
            {recentCoupons.map((coupon) => (
              <CouponCard key={coupon.id} coupon={coupon} />
            ))}
          </List>
        )}
      </Container>
    </Section>
  );
}
